<div class="card" *ngIf="submittedConsultant">
 <div class="ph-row p-md-2">
    <span class="text-double-dot" i18n>Your Recruiter is</span>
    <strong data-private>{{ submittedConsultant.recruiterInfo.fullName }}</strong>
  </div>
  <div class="ph-row px-md-2 pb-md-2">
    <span class="text-double-dot" i18n>Recruiter Phone</span>
    <strong data-private>{{ submittedConsultant.recruiterInfo.phoneNumber | phoneFormat}}</strong>
  </div>
</div>